<div>
	@if(showBalance){
	<div class="balance-container">
		<span class="title caption">{{
			balanceText
				? ("REQUEST.WITHDRAWAL.CRYPTO.WITHDARABLE" | translate)
				: ("GENERAL.BALANCE" | translate)
		}}</span>
		<span class="balance caption"
			>{{ balance | tcCurrency : precision }}
			{{ !crypto ? currency : "" }}</span
		>
	</div>
	}

	<div class="balance-slider">
		<mat-slider
			class="example-margin"
			[disabled]="balance === 0 || balance === undefined"
		>
			<input
				matSliderThumb
				[value]="percant"
				(valueChange)="rangeChanged($event)"
			/>
		</mat-slider>
		<!-- <div class="sp">
            <span>.</span>
            <span>.</span>
            <span>.</span>
            <span>.</span>
            <span>.</span>
        </div> -->
		<div class="percent">
			@if(crypto){
			<span class="-0 tooltips" tcTooltip>
				{{ "GENERAL.AT_LEAST" | translate }}
				@if(minValue){
				<span class="tooltip-text tooltip-bottom">
					{{ minValue | tcCurrency : precision }} {{ currency }}
				</span>
				}
			</span>
			} @else {
			<span class="-0"> {{ "GENERAL.AT_LEAST" | translate }}</span>
			}
			<span class="percent-25">25%</span>
			<span class="percent-50">50%</span>
			<span class="percent-75">75%</span>
			@if(crypto){
			<span class="percent-100 tooltips" tcTooltip
				>{{
					balanceText
						? ("REQUEST.WITHDRAWAL.CRYPTO.MAX" | translate)
						: "100%"
				}}
				@if(balance !== 0 && balance !== undefined){
				<span class="tooltip-text tooltip-bottom">
					{{ balance | tcCurrency : precision }} {{ currency }}
				</span>
				}
			</span>
			} @else {
			<span class="percent-100">100%</span>
			}
		</div>
	</div>
</div>

<!-- AT_LEAST -->
